import { writable, derived } from "svelte/store";

const lang = writable("fi");

// User inputs
const familySize = writable("single");
const income = writable(1500);
const selectedProvider = writable("");

// Hold state of all providers inputs
const allProviderDetails = writable({});

// API response
const settings = writable(null);

// Derived stores (selections from settings and/or calculations based on user input)
const incomeLimit = derived([familySize, settings], ([$size, $settings]) => {
	if ($settings.incomeLimits) {
		return $settings["incomeLimits"][$size];
	}
});

const minVoucherValue = derived(
	[familySize, settings],
	([$size, $settings]) => {
		if ($settings.minVoucherValue) {
			return $settings["minVoucherValue"][$size];
		}
	}
);

const maxVoucherValue = derived(
	[familySize, settings],
	([$size, $settings]) => {
		if ($settings.maxVoucherValue) {
			return $settings["maxVoucherValue"][$size];
		}
	}
);

const maxPayPercentage = derived(
	[familySize, settings],
	([$size, $settings]) => {
		if ($settings.maxPayPercentage) {
			return $settings["maxPayPercentage"][$size];
		}
	}
);

const voucherValue = derived(
	[maxVoucherValue, income, incomeLimit, maxPayPercentage],
	([$maxVoucherValue, $income, $incomeLimit, $maxPayPercentage]) =>
		$maxVoucherValue -
		(($income - $incomeLimit) * ($maxPayPercentage / 100)) / 60
);

const multipliers = derived(settings, ($settings) => {
	if ($settings.multipliers) {
		return $settings["multipliers"];
	}
});

const voucherValues = derived(
	[voucherValue, minVoucherValue, maxVoucherValue, multipliers],
	([$voucherValue, $minVoucherValue, $maxVoucherValue, $multipliers]) => {
		const multiplyVoucherValue = (value, multiplier) => {
			const multiplied = value * multiplier;
			const multipliedMin = $minVoucherValue * multiplier;
			const multipliedMax = $maxVoucherValue * multiplier;

			if (multiplied < multipliedMin) {
				return multipliedMin;
			}

			if (multiplied > multipliedMax) {
				return multipliedMax;
			}

			return multiplied;
		};

		return {
			Arkisin: {
				"7-18": multiplyVoucherValue(
					$voucherValue,
					$multipliers["weekday"]["7-18"]
				),
				"18-22": multiplyVoucherValue(
					$voucherValue,
					$multipliers["weekday"]["18-22"]
				),
			},
			Lauantai: {
				"7-18": multiplyVoucherValue(
					$voucherValue,
					$multipliers["saturday"]["7-18"]
				),
				"18-22": multiplyVoucherValue(
					$voucherValue,
					$multipliers["saturday"]["18-22"]
				),
			},
			Sunnuntai: {
				"7-18": multiplyVoucherValue(
					$voucherValue,
					$multipliers["sunday"]["7-18"]
				),
				"18-22": multiplyVoucherValue(
					$voucherValue,
					$multipliers["sunday"]["18-22"]
				),
			},
		};
	}
);

const servicePayPercentages = derived(settings, ($settings) => {
	if ($settings.servicePayPercentages) {
		return $settings["servicePayPercentages"];
	}
});

const serviceProviders = derived(settings, ($settings) => {
	if ($settings.serviceProviders) {
		return $settings["serviceProviders"];
	}
});

export {
	lang,
	settings,
	familySize,
	income,
	incomeLimit,
	selectedProvider,
	allProviderDetails,
	minVoucherValue,
	maxVoucherValue,
	voucherValue,
	voucherValues,
	servicePayPercentages,
	serviceProviders,
};
